import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { FooterComponent } from './layouts/footer/footer.component'
import { HeaderComponent } from './layouts/header/header.component';
import { SharedModule } from './shared/shared.module'
import { CoreModule } from './core/core.module';
import { DashboardNavComponent } from './layouts/dashboard-nav/dashboard-nav.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginShellComponent } from './modules/auth/pages/login-shell/login-shell.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { HttpModule } from '@angular/http';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MainSidebarComponent } from './layouts/main-layout/main-sidebar/main-sidebar.component';
import { MainHeaderComponent } from './layouts/main-layout/main-header/main-header.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { QuillModule } from 'ngx-quill'
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    HeaderComponent,
    FooterComponent,
    DashboardNavComponent,
    LoginShellComponent,
    SidebarComponent,
    MainLayoutComponent,
    MainSidebarComponent,
    MainHeaderComponent,
    AppLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    AngularFireFunctionsModule,
    // AngularFireAnalyticsModule,
    AngularFirestoreModule,
    CoreModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgbModule,
    HttpModule,
    TimepickerModule.forRoot(),
    QuillModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
